import { render, staticRenderFns } from "./validador.vue?vue&type=template&id=bd63e0b0&"
import script from "./validador.vue?vue&type=script&lang=js&"
export * from "./validador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports